// extracted by mini-css-extract-plugin
module.exports = {"widgetRow":"_172ecd5"};